module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./CollegeView.js"));
	}, "CollegeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CollegeView!./src/pages/Learn/College/CollegeView.js
// module id = 1225
// module chunks = 431